<template>
  <div class="content_login">
    <div class="loginbox">
      <div class="loginbox_f">
        <div class="carousexbox_i">
          <a-carousel autoplay class="carousexbox">
            <div>
              <!-- <img
              class="img"
              src="https://oss.tiantianhuoke.com/uploads/images/20230414/20b9b250ff206a38da1fdf0ed2ae0087.jpg"
              alt=""
            /> -->
              <img class="img" src="../../assets/images/login_1.jpg" alt="" />
            </div>
            <div>
              <!-- <img
              class="img"
              src="https://oss.tiantianhuoke.com/uploads/images/20230414/697d3827ad7b6014baf9ec4641ef86e3.jpg"
              alt=""
            /> -->
              <img class="img" src="../../assets/images/login_2.png" alt="" />
            </div>
          </a-carousel>
        </div>
        <div class="carousexbox_u">
          <span class="carousexbox_t">{{ title }}</span>
          <div class="carousexbox_c">
            <div class="carousexbox_r">
              <div v-if="isShow">
                <div class="text-center">
                  <a-tabs
v-model="activeKey"
@change="changeTab"
size="large"
:tabBarGutter="80"
                    style="display: block">
                    <a-tab-pane key="1" tab="账号登录" style="display: block"> </a-tab-pane>
                    <a-tab-pane key="2" tab="验证码登录" v-if="smsLoginEnabled"> </a-tab-pane>
                  </a-tabs>
                </div>
                <div>
                  <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rule1">
                    <div v-if="activeKey === '1'">
                      <a-alert
v-if="isLoginError"
type="error"
showIcon
style="margin-bottom: 24px"
                        :message="loginErrorInfo"
closable
:after-close="handleCloseLoginError" />
                      <a-form-model-item prop="accountNo">
                        <a-input v-model="form.accountNo" size="large" placeholder="请输入账户">
                          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
                        </a-input>
                      </a-form-model-item>
                      <a-form-model-item prop="password">
                        <a-input-password v-model="form.password" size="large" placeholder="请输入密码">
                          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
                        </a-input-password>
                      </a-form-model-item>
                      <a-form-model-item prop="rememberMe" class="text-left">
                        <div class="remmber_w">
                          <a-checkbox :checked="form.rememberMe" @change="rememberMe">记住密码</a-checkbox>
                          <a-button type="link" size="large" @click="handlePass"> 忘记密码 </a-button>
                        </div>
                      </a-form-model-item>
                      <a-form-model-item style="margin-top: 24px">
                        <!--开启图形验证码-->
                        <a-button
size="large"
type="primary"
htmlType="submit"
class="login-button"
:loading="logining"
                          :disabled="logining"
@click="handleSubCode"
                          v-if="captchaEnabled && activeKey == 1">确定</a-button>
                        <!--未开启图形验证码-->
                        <a-button
size="large"
type="primary"
htmlType="submit"
class="login-button"
:loading="logining"
                          :disabled="logining"
@click="handleSubmit"
v-if="!captchaEnabled">确定</a-button>
                      </a-form-model-item>
                    </div>
                    <a-row v-if="activeKey === '2'">
                      <a-form-model-item prop="mobile">
                        <a-input v-model="form.mobile" size="large" placeholder="手机号" :maxLength="11">
                          <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }" />
                        </a-input>
                      </a-form-model-item>
                      <div v-if="smsLoginEnabled">
                        <a-form-model-item prop="code">
                          <div style="position: relative">
                            <a-input
v-model="form.code"
size="large"
type="text"
autocomplete="off"
placeholder="验证码"
                              :maxLength="6">
                              <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
                            </a-input>
                            <span class="codeText">
                              <span v-if="mobileCodeTimer <= 0" @click="smsCodeVerify"> 获取验证码 </span>
                              <a-spin v-if="codeLoading" size="small">
                                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                              </a-spin>
                              <span v-if="mobileCodeTimer > 0"> {{ mobileCodeTimer }}秒后可重新获取 </span>
                            </span>
                          </div>
                        </a-form-model-item>
                        <a-form-model-item style="margin-top: 24px">
                          <a-button
size="large"
type="primary"
htmlType="submit"
class="login-button"
                            :loading="logining"
:disabled="logining"
@click="handleSubmit">登录</a-button>
                        </a-form-model-item>
                      </div>
                    </a-row>
                  </a-form-model>
                </div>
              </div>
              <div v-else>
                <div class="wang_m">
                  <!-- <a-tabs v-model="activeKey" @change="changeTab" size="large" :tabBarGutter="80">
                  <a-tab-pane key="1" tab="忘记密码"> </a-tab-pane>
                </a-tabs> -->
                  <a-button type="link">忘记密码</a-button>
                  <a-button type="link" @click="handlePass">返回</a-button>
                </div>
                <div class="wang_c">
                  <div>
                    <div class="wang_y">
                      <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rule1">
                        <div v-if="activeKey === '1'">
                          <a-alert
v-if="isLoginError"
type="error"
showIcon
style="margin-bottom: 24px"
                            :message="loginErrorInfo"
closable
:after-close="handleCloseLoginError" />
                          <a-form-model-item prop="mobile">
                            <a-input v-model="form.mobile" size="large" placeholder="请输入手机号" :maxLength="11">
                              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
                            </a-input>
                          </a-form-model-item>
                          <a-form-model-item prop="password">
                            <a-input-password v-model="form.password" size="large" :maxLength="12" placeholder="请输入新密码">
                              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
                            </a-input-password>
                          </a-form-model-item>
                          <a-form-model-item prop="confirmPassword">
                            <a-input-password
v-model="form.confirmPassword"
size="large"
:maxLength="12"
                              placeholder="请输入确认密码">
                              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
                            </a-input-password>
                          </a-form-model-item>
                          <a-form-model-item prop="validCode">
                            <div style="position: relative">
                              <a-input
v-model="form.validCode"
size="large"
type="text"
autocomplete="off"
                                placeholder="验证码"
:maxLength="6">
                                <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
                              </a-input>
                              <span class="codeText">
                                <span v-if="mobileCodeTimer <= 0" @click="smsCodeVerify"> 获取验证码 </span>
                                <a-spin v-if="codeLoading" size="small">
                                  <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                                </a-spin>
                                <span v-if="mobileCodeTimer > 0"> {{ mobileCodeTimer }}秒后可重新获取 </span>
                              </span>
                            </div>
                          </a-form-model-item>
                          <a-form-model-item style="margin-top: 24px">
                            <!--开启图形验证码-->
                            <a-button
size="large"
type="primary"
htmlType="submit"
class="login-button"
                              :loading="logining"
:disabled="logining"
@click="handleSubRet"
                              v-if="captchaEnabled && activeKey == 1">确定</a-button>
                            <!--未开启图形验证码-->
                            <a-button
size="large"
type="primary"
htmlType="submit"
class="login-button"
                              :loading="logining"
:disabled="logining"
@click="handleSubmit"
                              v-if="!captchaEnabled">确定</a-button>
                          </a-form-model-item>
                        </div>
                        <div class="user-login-other">
                          <div style="position: absolute; left: 0; top: 10px" v-if="captchaEnabled || smsLoginEnabled">
                            <!-- <Verify
                        ref="verify"
                        mode="pop"
                        @success="success"
                        :captchaType="'blockPuzzle'"
                        :imgSize="{ width: '330px', height: '155px' }"
                      ></Verify> -->
                          </div>
                        </div>
                      </a-form-model>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="user-login-other">
          <!-- <div style="position: fixed; left: 0; top: 0" v-if="captchaEnabled || smsLoginEnabled"></div> -->
          <Verify
ref="verify"
mode="pop"
@success="success"
:captchaType="'blockPuzzle'"
            :imgSize="{ width: '330px', height: '155px' }"></Verify>
        </div>
      </div>
    </div>
    <div class="login-copyright">
      <!-- {{ website.copyright }} -->
      <a href="https://beian.miit.gov.cn" style="color: #000;">鲁ICP备2023001168</a>
      <div class="login-cy">
        <a
href="https://xyt.xcc.cn/getpcInfo?sn=1821492779205779456&language=CN&certType=8&url=www.shengj.cn"
          target="_blank"
style="position: relative; display: inline-block; height: 38px">
          <div
style="
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
            "></div>
          <embed
src="https://program.xinchacha.com/web/1821492779205779456=www.shengj.cn.svg"
width="103"
height="38"
            type="image/svg+xml"
pluginspage="//www.adobe.com/svg/viewer/install/" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getSmsCode, getCodeImg, resetPass, getLoginConfig } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import Verify from '@/components/verifition/Verify.vue'
import { getRouters } from '@/api/menu'
import storage from 'store'
import defaultSettings from '@/config/defaultSettings'
import setting from '@/locales/lang/zh-CN/setting'

export default {
  components: {
    Verify,
  },
  ...mapActions(['Login', 'SmsLogin', 'Logout']),
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (this.form.password !== value) {
        callback(new Error('新密码和老密码不一致,请重新输入'))
      } else {
        callback()
      }
    }
    return {
      activeKey: '1',
      codeUrl: '',
      isLoginError: false,
      isShow: true,
      loginErrorInfo: '',
      mobileCodeTimer: 0,
      codeText: '获取验证码',
      codeLoading: false,
      form: {
        accountNo: '',
        password: '',
        mobile: '',
        code: undefined,
        validCodeReqNo: '',
        uuid: '',
        rememberMe: false,
      },
      rules: {},
      rule1: {
        accountNo: [{ required: true, message: '请输入帐户', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'change' },
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        validCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      rule3: {
        code: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
      },
      rule2: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur',
          },
        ],
        password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'change' },
        ],
        validCode: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
      },
      logining: false,
      captchaEnabled: false,
      smsLoginEnabled: false,
      redirect: undefined,
      title: '',
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true,
    },
    // activeKey: {
    //   handler: function (newVal) {
    //     if (newVal) {
    //       this.$refs.form.resetFields()
    //       this.logining = false
    //       if (newVal === '1') {
    //         this.rules = this.rule1
    //         this.form.username = "";
    //         this.form.password = "";
    //       } else if (newVal === '2') {
    //         this.form.code = "";
    //         this.form.mobile = "";
    //         this.rules = this.rule2
    //       }
    //     }
    //   },
    //   immediate: true
    // }
  },
  created() {
    this.getStorage()
    this.rules = this.rule1
    this.getConfig()
    this.title = defaultSettings.title
    console.log(this.$router.options.routes, '的点点滴滴')

    // console.log(defaultSettings,'defaultSettingsdefaultSettings');
  },
  methods: {
    /**
     * 滑块验证插件
     */
    success(params) {
      console.log(params, 'paramsparamsparams')
      this.form.captchaVerification = params.captchaVerification
      if (this.isShow) {
        if (this.activeKey == 1) {
          this.handleSubmit()
        } else if (this.activeKey == 2) {
          this.getSmsCode()
        }
      } else {
        this.getSmsCode()
      }
    },
    // 点击显示滑块验证弹窗
    userLoginVerify() {
      this.$refs.verify.show()
    },
    // 点击显示滑块验证弹窗
    smsCodeVerify() {
      // 校验手机号
      const field = 'mobile' // 要验证的字段名
      this.$refs.form.validateField(field, (error) => {
        if (!error) {
          console.log('验证通过')
          this.$refs.verify.refresh()
          setTimeout(() => {
            this.$refs.verify.show()
          }, 10)
        } else {
          console.log('验证失败', error)
        }
      })
      // if (this.isShow) {
      //   this.$refs.form.validateField(field, (error) => {
      //     if (!error) {
      //       console.log('验证通过')
      //       this.$refs.verify.refresh()
      //       setTimeout(() => {
      //         this.$refs.verify.show()
      //       }, 10)
      //     } else {
      //       console.log('验证失败', error)
      //     }
      //   })
      //   // this.$refs.form.validate((valid, object) => {
      //   //   if (valid) {
      //   //     this.$refs.verify.refresh()
      //   //     setTimeout(() => {
      //   //       this.$refs.verify.show()
      //   //     }, 10)
      //   //   }
      //   // })
      // } else {
      //   this.$refs.form.validateField(field, (error) => {
      //     if (!error) {
      //       console.log('验证通过')
      //       this.$refs.verify.refresh()
      //       setTimeout(() => {
      //         this.$refs.verify.show()
      //       }, 10)
      //     } else {
      //       console.log('验证失败', error)
      //     }
      //   })
      //   // if (!this.form.mobile) return this.$message.error('请输入手机号')
      //   // const leg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      //   // if (!leg.test(this.form.mobile)) return this.$message.error('请输入正确的手机号')
      // }
    },
    // 点击跳转忘记密码
    handlePass() {
      console.log(this.$route, '对对对对对对')
      this.isShow = !this.isShow
      this.form = {
        accountNo: '',
        password: '',
        mobile: '',
        code: undefined,
        validCodeReqNo: '',
        uuid: '',
        rememberMe: false,
      }
      // this.$router.push('/register')
    },
    changeTab() {
      if (this.activeKey === '1') {
        this.rules = this.rule1
      } else if (this.activeKey === '2') {
        this.rules = this.rule2
      }
    },
    /** —————————————————————————— 获取配置项，验证码和图形验证码是否开启 start ——————————————————————————*/
    getConfig() {
      this.captchaEnabled = true
      this.smsLoginEnabled = true
      // getLoginConfig().then((res) => {
      //   console.log(res, 'resresresresres')
      //   // this.captchaEnabled = res.data.captchaEnabled
      //   // this.smsLoginEnabled = res.data.smsLoginEnabled
      //   // this.captchaEnabled = false
      //   // this.smsLoginEnabled = false
      //   this.captchaEnabled = true
      //   this.smsLoginEnabled = true
      // })
    },
    /** —————————————————————————— 获取配置项，验证码和图形验证码是否开启 end   ——————————————————————————*/

    /** —————————————————————————— 发送短信验证码 start —————————————————————————— **/
    getSmsCode() {
      if (this.isShow) {
        const field = 'mobile' // 要验证的字段名
        // this.$refs.form.validate((valid, object) => {
        //   if (valid) {
        //     if (this.mobileCodeTimer > 0) return
        //     this.codeLoading = true
        //     getSmsCode({
        //       mobile: this.form.mobile,
        //       templateCode: 'MOBILE_LOGIN',
        //       captchaVerification: this.form.captchaVerification,
        //     })
        //       .then((res) => {
        //         this.codeLoading = false
        //         if (res.success) {
        //           this.mobileCodeTimer = 60
        //           this.form.validCodeReqNo = res.data
        //           let msgTimer = setInterval(() => {
        //             this.mobileCodeTimer = this.mobileCodeTimer - 1
        //             if (this.mobileCodeTimer <= 0) {
        //               clearInterval(msgTimer)
        //             }
        //           }, 1000)
        //         } else {
        //           this.$message.error(res.message)
        //         }
        //       })
        //       .catch(() => {
        //         setTimeout(() => {
        //           this.codeLoading = false
        //         }, 5000)
        //       })
        //   }
        // })
        this.$refs.form.validateField(field, (error) => {
          if (!error) {
            if (this.mobileCodeTimer > 0) return
            this.codeLoading = true
            getSmsCode({
              mobile: this.form.mobile,
              templateCode: 'MOBILE_LOGIN',
              captchaVerification: this.form.captchaVerification,
            })
              .then((res) => {
                this.codeLoading = false
                if (res.success) {
                  this.mobileCodeTimer = 60
                  this.form.validCodeReqNo = res.data
                  const msgTimer = setInterval(() => {
                    this.mobileCodeTimer = this.mobileCodeTimer - 1
                    if (this.mobileCodeTimer <= 0) {
                      clearInterval(msgTimer)
                    }
                  }, 1000)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch(() => {
                setTimeout(() => {
                  this.codeLoading = false
                }, 5000)
              })
          } else {
            console.log('验证失败', error)
          }
        })
      } else {
        if (this.mobileCodeTimer > 0) return
        this.codeLoading = true
        getSmsCode({
          mobile: this.form.mobile,
          templateCode: 'MOBILE_LOGIN',
          captchaVerification: this.form.captchaVerification,
        })
          .then((res) => {
            this.codeLoading = false
            if (res.success) {
              this.mobileCodeTimer = 60
              this.form.validCodeReqNo = res.data
              const msgTimer = setInterval(() => {
                this.mobileCodeTimer = this.mobileCodeTimer - 1
                if (this.mobileCodeTimer <= 0) {
                  clearInterval(msgTimer)
                }
              }, 1000)
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.codeLoading = false
            }, 5000)
          })
      }
    },
    getStorage() {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form = {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe,
        }
      }
    },
    // 点击忘记密码重置密码
    handleSubRet() {
      this.$refs.form.validate((valid, object) => {
        // this.logining = true
        if (valid) {
          // this.$refs.verify.show()
          resetPass(this.form)
            .then((res) => {
              this.$message.success('修改成功')
              this.isShow = true
              this.form = {
                accountNo: '',
                password: '',
                mobile: '',
                code: undefined,
                validCodeReqNo: '',
                uuid: '',
                rememberMe: false,
              }
            })
            .catch((err) => {
              // this.loading = false
              // setTimeout(() => {
              //   this.logining = false
              // }, 1000)
            })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    handleSubCode() {
      console.log(11111)
      this.$refs.form.validate((valid, object) => {
        // this.logining = true
        if (valid) {
          this.$refs.verify.show()
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    handleSubmit() {
      this.logining = true
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.accountNo)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          let loginApi = ''
          if (this.activeKey === '1') {
            loginApi = 'Login'
          } else if (this.activeKey === '2') {
            if (this.smsLoginEnabled) {
              loginApi = 'SmsLogin'
            }
          }
          console.log(this.form)
          this.$store
            .dispatch(loginApi, this.form)
            .then((res) => {
              console.log(res, 'resresresc测试数据===')
              // console.log(this.$router.options.routes, 'this.$routerthis.$router')
              // this.$router.push('/user/home')
              getRouters().then((res) => {
                res = res.data
                if (res && res.length) {
                  console.log(res, 'ddddd的点点滴滴')
                  if (res[0].children && res[0].children.length) {
                    // console.log( res.children[0], '111333yYYYYuuu')
                    const path = '/' + res[0].name + '/' + res[0].children[0].path
                    console.log(path, 'pathpath111333yYYYYuuu')
                    this.$router.push(path)
                  } else {
                    console.log(res[0].name, '111333yYYYYuuu9999')
                    this.$router.push('/' + res[0].name)
                  }
                } else {
                  this.$router.push('/')
                }
              })
            })
            .catch((err) => {
              this.loading = false
              setTimeout(() => {
                this.logining = false
              }, 1000)
            })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      // this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`,
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    },
    onChange() { },
    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },
  },
}
</script>

<style lang="less" scoped>
.content_login {
  width: 100%;
  height: 100vh;
  background: url(~@/assets/login_bg.png) no-repeat;
}

.top {
  text-align: center;

  .header {
    height: 44px;
    line-height: 44px;

    .badge {
      position: absolute;
      display: inline-block;
      line-height: 1;
      vertical-align: middle;
      margin-left: -12px;
      margin-top: -10px;
      opacity: 0.8;
    }

    .logo {
      height: 44px;
      vertical-align: top;
      margin-right: 16px;
      border-style: none;
    }
  }

  .desc {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 12px;
    margin-bottom: 40px;
  }
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}

.loginbox {
  width: 1300px;
  // width: 85%;
  // width: 1800px;
  margin: 0 auto;
  background-color: #fff;
  // background: red;
  border-radius: 16px;
  height: 85vh;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  // background: red;

  .title2 {
    font-size: 20px;
  }

  .img {
    // width: 750px;
    // height: 605px;
    // width: 1900px;
    width: 100%;
    height: 100%;
    height: 85vh;
    display: inline-block;
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    display: block;
    object-fit: cover;
  }
}

/deep/.ant-carousel .slick-dots-bottom {
  bottom: 20px;
}

/deep/.ant-carousel .slick-dots li button {
  height: 6px;
  width: 10px;
  border-radius: 5px;
  background: rgba(0, 82, 199, 0.7);
}

/deep/.ant-carousel .slick-dots li.slick-active button {
  background: #0052c7 !important;
  border-radius: 5px;
  width: 24px;
}

.codeText {
  color: #1890ff;
  position: absolute;
  padding: 0 10px;
  right: 10px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
}

.remmber_w {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.login_main {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  padding: 100px 30px 0;
}

/deep/.ant-tabs-tab {
  font-size: 24px !important;
}

/deep/.ant-input {
  height: 50px !important;
  font-size: 20px !important;
  // padding-left: 30px !important;

  // margin-bottom: 30px;
}

/deep/.ant-input-prefix {
  font-size: 20px !important;

  // margin-right: 100px !important;
  // margin-left: 100px !important;
}

.codeText {
  font-size: 20px !important;
}

/deep/.ant-form-explain {
  font-size: 20px !important;
}

.ant-form-item {
  margin-bottom: 20px !important;
}

/deep/ .ant-checkbox {
  font-size: 20px !important;
}

.wang {
  width: 100%;
  height: 80%;

  .wang_t {
    font-size: 30px;
    color: #000;
    padding-top: 30px;
    cursor: pointer;
  }
}

/deep/.ant-input-lg {
  padding-left: 40px !important;
}

.loginbox_f {
  display: flex;
  align-content: center;

  .carousexbox_i {
    width: 50%;
    height: 85vh;

    // background: red;
    .carousexbox {
      width: 100%;
      height: 100%;
    }
  }
}

.carousexbox_u {
  width: 50%;
  height: 85vh;
  padding-top: 40px;

  .carousexbox_t {
    font-size: 40px;
    color: rgba(0, 0, 0, 0.85);
    font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
    font-weight: 600;
    margin-left: 40px;
  }

  .carousexbox_c {
    display: flex;
    margin-top: 30px;
    justify-content: center;

    .carousexbox_r {
      width: 80%;

      .text-center {
        width: 100%;
      }

      .user-layout-login {
        width: 100%;

        label {
          font-size: 14px;
        }

        .getCaptcha {
          display: block;
          width: 100%;
          height: 40px;
          cursor: pointer;
        }

        button.login-button {
          padding: 0 15px;
          font-size: 20px;
          height: 60px;
          width: 100%;
        }
      }
    }

    .wang_m {
      font-size: 30px;
      margin-bottom: 20px;
      font-weight: 500;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      button {
        font-size: 26px !important;
      }
    }
  }
}

.user-login-other {
  text-align: left;
  margin-top: 24px;
  line-height: 22px;

  .register {
    float: right;
  }
}

/deep/.ant-tabs-tab {
  border: none !important;
  padding-top: 0 !important;
}

.ant-tabs-bar {
  border: none !important;
  /* 取消元素的阴影效果 */
  box-shadow: none !important;
  height: 45px !important;
  padding-top: 5px !important;
}

// /deep/.ant-tabs-tab{
//   display: block !important;

// }
.login-copyright {
  position: fixed;
  bottom:10px;
  left: 50%;
  transform: translateX(-50%);
.login-cy{
  text-align: center;
}
  a {
    color: #fff;
    font-size: 26px;
  }
}
</style>
